import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import termsOfService from "@faire/web-api--source/routes/tos";
import * as React from "react";

export const termsOfServiceLinkFormatting = (chunks: React.ReactNode) => (
  <EmbeddedLink linkTo={termsOfService()} target="_blank">
    {chunks}
  </EmbeddedLink>
);
